import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-solid-svg-icons';
import {Component} from 'react';

class LoginIcon extends Component {
    constructor(props) {
        super(props);
         this.state = {
         }
    }

    render() { 
        return <>
            <div onClick={() => this.handleClick()}>
                <FontAwesomeIcon icon={faUserCircle} className="login-icon"/>
            </div>
        </>
    }

    handleClick()
    {
        this.props.toggleLoginMenu();
    }
}

export default LoginIcon;